import { Sunrise, Target } from "lucide-react"
import { useUser } from "contexts/UserContext"

interface NewChatViewProps {
  onQuickAction: (actionId: string) => void
  compact?: boolean
}

const QUICK_ACTIONS = [
  {
    id: "brief-today",
    icon: Sunrise,
    label: "Brief di oggi",
    bg: "var(--hexa-warning-light)",
    border: "var(--hexa-warning)",
    iconColor: "var(--hexa-warning)",
  },
  {
    id: "focus-now",
    icon: Target,
    label: "Su cosa lavoro ora?",
    bg: "var(--hexa-info-light)",
    border: "var(--hexa-info)",
    iconColor: "var(--hexa-info)",
  },
]

export function NewChatView({ onQuickAction, compact = false }: NewChatViewProps) {
  const { user } = useUser()
  const greeting = user?.first_name
    ? `Ciao ${user.first_name}! Come posso aiutarti?`
    : "Ciao! Come posso aiutarti?"

  return (
    <div
      className={
        compact
          ? "flex shrink-0 flex-col items-center justify-center px-2 py-2 mt-auto"
          : "flex-1 flex flex-col items-center justify-center px-4 py-6"
      }
    >
      {/* Title */}
      <p
        className="text-sm font-medium mb-5 text-center"
        style={{ color: "var(--hexa-text-secondary)" }}
      >
        {greeting}
      </p>

      {/* Quick action chips */}
      <div className="flex flex-wrap justify-center gap-2">
        {QUICK_ACTIONS.map((action) => {
          const Icon = action.icon
          return (
            <button
              key={action.id}
              onClick={() => onQuickAction(action.id)}
              className="inline-flex items-center gap-1.5 cursor-pointer transition-opacity hover:opacity-80"
              style={{
                fontSize: "12px",
                padding: "4px 10px",
                borderRadius: "12px",
                background: action.bg,
                border: `1px solid ${action.border}`,
                color: "var(--hexa-text-primary)",
              }}
            >
              <Icon className="w-3 h-3" style={{ color: action.iconColor }} />
              {action.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
